import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import PageMappingForm from "../../components/PageMapping/PageMappingForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams,useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getPageMappingById,
  setPageMapping,
} from "../../../core/actionCreators/pageMappingActionCreator";

const PageMaping = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageMode, setPageMode] = useState("");
  const { pageMaping } = useSelector((s: any) => s.pageMappingStore);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/pageMapping/create") {
      setPageMode("CREATE");
    } else {
      if (params.id) {
        setPageMode("EDIT");
        dispatch(getPageMappingById(params.id, null));
      }
    }
    return () => {
      dispatch(setPageMapping({}));
    };
  }, [params, window]);

  const backArrowClickHandler = () => {
    navigate("/pageMapping");
  };

  return (
    <>
      <div className="flex mainWrapper w-full">
        <div className="sidenav-wrapper">
          <SideNavbar />
        </div>
        <div className="right-container">
          <div className="header-container">
            <Header />
          </div>
          <div className="body-container">
            <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
              <div className="flex items-center w-full">
                <ArrowLeftSLineIcon
                  onClick={backArrowClickHandler}
                  size={24}
                  className="mr-4 cursor-pointer"
                />
                <p className="text-xl font-bold text-[#43425D] flex items-center">
                 {pageMode=== "CREATE"? "Create": "Update"} Param
                </p>
              </div>
            </div>
            <PageMappingForm pageMode={pageMode} pageMaping={pageMaping} />
          </div>
        </div>
      </div>
    </>
  );
};
export default PageMaping;
